module.exports = __webpack_public_path__ + "static/contact_rocket-8c12ec0ce72708e98f9411eedb85bba7.svg";